import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "placeholder"];
var __jsx = React.createElement;
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import stl from './RHFTextarea.module.css';
import { useTranslation } from '@i18n';
var RHFTextarea = function RHFTextarea(_ref) {
  var name = _ref.name,
    placeholder = _ref.placeholder,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field,
        error = _ref2.fieldState.error;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", _extends({
        className: stl.textarea,
        placeholder: placeholder
      }, field, other)), error && /*#__PURE__*/React.createElement("span", {
        className: "errorText"
      }, tShort(error.message, {
        ns: "validations"
      })));
    }
  });
};
export default RHFTextarea;